export default theme => ({
  root: {
    borderBottom: '1px solid #e8e8e8',
    marginBottom: theme.spacing(3),
  },
});
